import { useContext, useEffect, useState } from "react";
import { Modal } from "@mui/material";
import { Box } from "@mui/material";
import StyledButton from "../../../custom/StyledButton";
import StyledInput from "../../../custom/StyledInput";
import useGetDevice from "../../../../../hooks/useGetDevice";
import { useSnackbar } from "../../../../../hooks/SnackbarProvider";
import { UserContext } from "../../../../../../../../App";
import { AddDeliveryChargeCart } from "../../../../../../../../config/Services";

export const DeliveryModal = ({ handleCloseDeliveryPopUp, openDelivery }) => {
  const { color } = useContext(UserContext);
  const isMobile = useGetDevice();
  const showSnackbar = useSnackbar();
  const [rpLoader, setRpLoader] = useState(false);
  const [charge, setCharge] = useState("0");
  const suggestions = [10, 20, 30, 40, 50, 100];
  const CartId = localStorage.getItem("CartId");
  useEffect(() => {
    if (!openDelivery) return;
    const handleDeliveryChargeAdd = (e) => {
      if (e?.key === "Enter") {
        AddDeliveryCharge();
      }
    };
    document.addEventListener("keydown", handleDeliveryChargeAdd);
    return () => {
      document.removeEventListener("keydown", handleDeliveryChargeAdd);
    };
  }, []);

  const AddDeliveryCharge = () => {
    const payload = {
      cartId: CartId,
      value: charge,
      freeDelivery: false,
      inventoryCheck: "YES",
    };
    AddDeliveryChargeCart(payload).then((res) => {
      console.log({ res });
    });
  };
  return (
    <Modal open={openDelivery} onClose={handleCloseDeliveryPopUp}>
      <Box
        sx={{
          backgroundColor: color === "dark" ? "#353a50" : "#fff",
          color: color === "dark" ? "white" : "black",
          position: isMobile ? "static" : "fixed",
          top: "50%",
          left: "10%",
          maxWidth: isMobile ? "100%" : "40%",
          maxHeight: "100%",
          transform: isMobile ? "none" : "translate(50%, -50%)",
          width: isMobile ? "100%" : "50%",
          display: isMobile ? "flex" : "block",
          borderRadius: "10px",
          padding: "1.5rem",
          flexDirection: "column",
          justifyContent: "center",
          ...(isMobile && { height: "100%" }),
        }}
      >
        <div className="">
          <p>Add delivery charge for this order here.</p>
          <StyledInput
            type="number"
            placeholder="Enter the amount recieved"
            sx={{ width: "100%", marginTop: "1rem" }}
            autoFocus
            value={charge}
            onChange={(e) => setCharge(e.target.value)}
          />
          <div className="suggestions-box">
            {suggestions.map((suggestion, index) => (
              <div key={index} className="suggestion" onClick={() => setCharge(suggestion)}>
                ₹{suggestion}
              </div>
            ))}
          </div>
          <div className="record-payment-button">
            <StyledButton fullWidth onClick={handleCloseDeliveryPopUp}>
              Cancel
            </StyledButton>
            <StyledButton fullWidth loading={rpLoader} onClick={() => AddDeliveryCharge()}>
              Add
            </StyledButton>
          </div>
        </div>
      </Box>
    </Modal>
  );
};
